import React from 'react';
import { DataGridUI, DataGridIdentifiers } from '../Interface';
import { dataGridColumns } from '../../utils/helper';
import { TaskReport } from '../../config/taskReport';

const PlanTaskReportsTable = ({ reportList }) => {
  const columns = dataGridColumns([
    {
      field: 'timeSpent',
      headerName: 'Ráfordított idő',
      flex: 0.5,
      valueGetter: (params) => {
        const me = params.row.me;
        const timeSpent = params.row.timeSpent;
        const formattedTimeSpent = me === TaskReport.óra ? 'óra' : 'perc';
        return `${timeSpent} ${formattedTimeSpent}`;
      },
    },
    {
      field: 'typeId',
      headerName: 'Feladattípus',
      flex: 0.5,
      valueGetter: (params) => {
        const taskType = params.row.taskType?.itemName;
        return taskType;
      },
    },
    {
      field: 'description',
      headerName: 'Megjegyzés',
      flex: 1,
    },
  ]);

  return (
    <DataGridUI
      getRowHeight={() => 'auto'}
      datagridIdentifier={DataGridIdentifiers.PlanTaskTaskReports}
      sx={{ height: 440, width: '100%' }}
      columns={columns}
      rows={reportList}
    />
  );
};

export default PlanTaskReportsTable;
